<template>
	<section>
		<header>
			mNews
			<a href="https://www.mforex.pl/mnews/#/market" target="_blank"
				>zobacz wszystkie</a
			>
		</header>

		<div v-for="news in newsListSliced" :key="news.id" class="news-item">
			<p class="news-time">
				<span>
					<img src="images/clock-gray.svg" width="14" />
				</span>
				<span>{{ $filters.time(news.creationDate) }}</span>
				<span>{{ news.dayOfWeek }} </span>
				<span> {{ $filters.date(news.creationDate) }}</span>
			</p>
			<a
				:href="news.postUrl"
				target="_blank"
				style="text-decoration: none; color: #201c17"
			>
				<h4>{{ news.title }}</h4>
			</a>
			<p
				v-html="
					news.headerText.length > 130
						? news.headerText.substring(0, 130) + '...'
						: news.headerText
				"
			></p>
		</div>
		<!-- <div class="my-3">&nbsp;</div> -->
	</section>
</template>

<script>
export default {
	computed: {
		newsList() {
			return this.$store.getters.getNewsList
				? this.$store.getters.getNewsList
				: [];
		},
		newsListSliced() {
			return this.newsList.slice(0, 3);
		},
	},
	mounted() {
		this.$store.dispatch('fetchNewsList');
	},
};
</script>
